import { render, staticRenderFns } from "./input-view.vue?vue&type=template&id=07c124fb&scoped=true&"
import script from "./input-view.vue?vue&type=script&lang=js&"
export * from "./input-view.vue?vue&type=script&lang=js&"
import style0 from "./input-view.vue?vue&type=style&index=0&id=07c124fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c124fb",
  null
  
)

export default component.exports